import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { InventoryDetailsTabProps, ReceivingHistoryData, ReceivingHistoryPayload } from './model/inventoryOverview.model';
import Table, { Column } from '../../../Components/Tables/Table';
import { getReceivingHistory } from './service/inventoryOverview.service';
import { ApiResponse } from '../../../model/common/apiResponse';
import Loader from '../../../Components/GlobalLoader/Loader';
import { formatDate } from '../../../Utility/Utility';
import { usePagination } from '../../../hooks/usePagination';

export const ReceivingHistory:React.FC<InventoryDetailsTabProps> = ({
    warehouseId
}) => { 
    const { id } = useParams();
    const [receivingHistoryData, setReceivingHistoryData] = useState<ApiResponse<any> | null>(null);
    const [loading, setLoading] = useState(true);
    const { currentPage, handlePageChange, perPage } = usePagination();
    let payload = { ...ReceivingHistoryPayload };

    const Columns: Column[] = [
        {
            name: "Recv Date",
            selector: (row: ReceivingHistoryData) => row?.created_at ? formatDate(row?.created_at) : '-',
        },
        {
            name: "ASN #",
            selector: (row: ReceivingHistoryData) => row?.id ? row?.id : 0,
        },
        {
            name: "Supplier Name",
            selector: (row: ReceivingHistoryData) => row?.supplier_name ? row?.supplier_name : '-',
        },
        {
            name: "Primary Ref#",
            selector: (row: ReceivingHistoryData) => row?.reference_1 ? row?.reference_1 : '-',
        },
        {
            name: "Qty Received",
            selector: (row: ReceivingHistoryData) => row?.qty_received ? row?.qty_received : 0,
        },
    ];

    useEffect(() => {
        if (id) {
            setLoading(true);
            payload.conditions = [
                ["inbound_shipment.warehouse_id", "=", warehouseId],
                ["receipt_detail.item_id", "=", id]
            ];
            payload.order = [
                {
                    "column": "receipt_detail.created_at",
                    "dir": "desc"
                }
            ];
            payload.group = [
                "inbound_shipment.id"
            ];
            payload.limit = perPage;
            payload.page = currentPage;
            getReceivingHistory(payload).then((response) => {
                setReceivingHistoryData(response ?? null);
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [id, currentPage])

    return !loading ? (
        <div className="mb-2 mt-1 bg-white rounded px-4 py-3">
            <Table
                columns={Columns}
                data={receivingHistoryData?.data?.results || []}
                isStripped={true}
                CheckboxStatus={false}
                pagination={{
                    recordsPerPage: perPage,
                    totalRecords: receivingHistoryData?.data?.recordsTotal,
                    currentPage: currentPage,
                    onCurrentPageChange: handlePageChange,
                }}
            />
        </div>
    ) : <Loader />;
}
